import { render, staticRenderFns } from "./LocalisationMenu.vue?vue&type=template&id=c02c4fd6&scoped=true&"
import script from "./LocalisationMenu.vue?vue&type=script&lang=js&"
export * from "./LocalisationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02c4fd6",
  null
  
)

export default component.exports